import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FaShoppingCart, FaUserTie, FaIndustry } from 'react-icons/fa';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';

// import buyerImg from '../../../assets/buyer.png';
// import agentImg from '../../../assets/agent.png';
// import factoryImg from '../../../assets/factory.png';

import css from './BenefitsSection.module.css';
import { BsCartFill } from 'react-icons/bs';
import { FaCheckCircle } from 'react-icons/fa';
import { text } from 'body-parser';

/**
 * Benefits Section component for ChinaDolphins custom homepage
 * Featuring alternating SaaS layout sections without TODO tags
 */
const BenefitsSection = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  const intl = useIntl();

  const formatBenefit = id => {
    const msg = intl.formatMessage({ id });
    // Remove leading bullet characters (like •), asterisks, dashes, and extra spaces
    return msg.replace(/^[•\-\*\s]+/, '').trim();
  };

  return (
    <div className={css.main}>
      <h2 style={{ display: 'none' }}>
        <FormattedMessage id="landing.benefits.title" />
      </h2>
      <div className={css.card}>
        <div className={css.icon}>
          <div className={css.ic}>
            <BsCartFill size={25} />
          </div>
          <h1 className={css.text}>
            <FormattedMessage id="landing.benefits.buyerTitle" />
          </h1>
        </div>
        <div className={css.flex}>
          <div className={css.left}></div>
          <div className={css.rightt}>
            <ul className={css.list}>
              <li className={css.listItem}>
                <FaCheckCircle className={css.icon} />
                <span>
                  {formatBenefit('landing.benefits.buyerDesc1')}
                </span>
              </li>
              <li className={css.listItem}>
                <FaCheckCircle className={css.icon} />
                <span>
                  {formatBenefit('landing.benefits.buyerDesc2')}
                </span>
              </li>
              <li className={css.listItem}>
                <FaCheckCircle className={css.icon} />
                <span>
                  {formatBenefit('landing.benefits.buyerDesc3')}
                </span>
              </li>
            </ul>

            <button className={css.button}>
              <FormattedMessage id="landing.benefits.buyerCTA" />
            </button>
          </div>
        </div>
      </div>
      <div className={css.card2}>
        <div className={css.icon}>
          <div className={css.ic2}>
            <BsCartFill size={25} />
          </div>
          <h1 className={css.textt}>
            <FormattedMessage id="landing.benefits.agentTitle" />
          </h1>
        </div>
        <div className={css.flex}>
          <div className={css.left2}></div>
          <div className={css.rightt}>
            <ul className={css.list}>
              <li className={css.listItem}>
                <FaCheckCircle className={css.icon2} />
                <span>
                  {formatBenefit('landing.benefits.agentDesc1')}
                </span>
              </li>
              <li className={css.listItem}>
                <FaCheckCircle className={css.icon2} />
                <span>
                  {formatBenefit('landing.benefits.agentDesc2')}
                </span>
              </li>
              <li className={css.listItem}>
                <FaCheckCircle className={css.icon2} />
                <span>
                  {formatBenefit('landing.benefits.agentDesc3')}
                </span>
              </li>
            </ul>

            <button className={css.button2}>
              <FormattedMessage id="landing.benefits.agentCTA" />
            </button>
          </div>
        </div>
      </div>
      <div className={css.card3}>
        <div className={css.icon}>
          <div className={css.ic3}>
            <BsCartFill size={25} />
          </div>
          <h1 className={css.texttt}>
            <FormattedMessage id="landing.benefits.factoryTitle" />
          </h1>
        </div>
        <div className={css.flex}>
          <div className={css.left3}></div>
          <div className={css.rightt}>
            <ul className={css.list}>
              <li className={css.listItem}>
                <FaCheckCircle className={css.icon3} />
                <span>
                  {formatBenefit('landing.benefits.factoryDesc1')}
                </span>
              </li>
              <li className={css.listItem}>
                <FaCheckCircle className={css.icon3} />
                <span>
                  {formatBenefit('landing.benefits.factoryDesc2')}
                </span>
              </li>
              <li className={css.listItem}>
                <FaCheckCircle className={css.icon3} />
                <span>
                  {formatBenefit('landing.benefits.factoryDesc3')}
                </span>
              </li>
            </ul>

            <button className={css.button3}>
              <FormattedMessage id="landing.benefits.factoryCTA" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

BenefitsSection.defaultProps = {
  className: null,
  rootClassName: null,
};

BenefitsSection.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default BenefitsSection;
